<template>
  <div class="myusers f-s-s f-d-c w-100 p-5">
    <div class="header f-c-b w-100 mb-3">
      <div class="f-c-b searchBox w-100">
        <div class="tableTitle f-c-c">کاربران من</div>
        <div class="search f-c-c">
          <input
            v-if="isSearchActive"
            :class="[isSearchActive ? 'searchInputActive pb-0' : '']"
            @keyup="searchFunc"
            type="text"
            placeholder="جستجو"
          />
          <b-img
            :class="[isSearchActive ? 'imgActive' : '']"
            :src="require(`@/assets/images/gap/search-icon.svg`)"
            @click="searchIconFunc()"
          ></b-img>
        </div>
      </div>
      <!-- <div class="search f-c-c">
        <b-img :src="require(`@/assets/images/gap/search-icon.svg`)"></b-img>
        <input v-model="searchUser" type="text" placeholder="جستجو" />
      </div> -->
      <!-- <div @click.prevent="addNewUserFunc()" class="addUser f-c-c">
        <span class="plus ml-2">+</span>
        <div class="text f-c-c">افزودن کاربر</div>
      </div> -->
    </div>
    <div class="userTable userTable-color f-c-c f-d-c w-100">
      <div class="header f-c-s w-100">
        <div class="headerItem f-c-s w-5"></div>
        <div class="headerItem f-c-s w-22">نام</div>
        <div class="headerItem f-c-s w-13">موبایل</div>
        <!-- <div class="headerItem f-c-s w-15">ایمیل</div> -->
        <div class="headerItem f-c-s w-15">سازمان</div>
        <div class="headerItem f-c-s w-15">وضعیت</div>
        <div class="headerItem f-c-s w-10">کد</div>
        <div class="headerItem f-c-c w-20">عملیات</div>
      </div>
      <div v-if="itemsForList.length" class="tableContent f-c-c f-d-c w-100">
        <div
          v-for="(v, i) in itemsForList"
          :key="i"
          class="tableRow f-c-s w-100"
          :class="[v.flag == 'confirmed' ? 'grrenBack' : v.flag == 'rejected' ? 'redBack' : '']"
        >
          <div class="tableItem f-c-c w-5">{{ v.row }}</div>
          <div class="tableItem f-c-s w-22">
            <div
              class="f-c-s w-90"
              :title="v.first_name + ' ' + v.last_name"
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ v ? v.first_name + " " + v.last_name : "-" }}
            </div>
          </div>
          <div class="tableItem f-c-s w-13">
            {{ v.mobile ? v.mobile : "-" }}
          </div>
          <!-- <div class="tableItem f-c-s w-15">
            <div
              class="f-c-s w-90"
              :title="v.email"
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ v.email ? v.email : "-" }}
            </div>
          </div> -->
          <div class="tableItem f-c-s w-15">
            <span :title="v.user_organ_title">{{
              v.user_organ_title ? v.user_organ_title : "-"
            }}</span>
          </div>
          <div class="tableItem f-c-s w-15">
            {{ v.status ? v.status : "-" }}
          </div>
          <div class="tableItem f-c-s w-10">
            {{ v.active_code ? v.active_code : "-" }}
          </div>
          <div class="tableItem f-c-sa w-20">
            <div
              v-if="user.permissions.confirmation_user"
              class="okBox f-c-c ml-1"

              @click.prevent="editUserFunc(v)"
            >
              تایید
            </div>
            <div
              v-if="user.permissions.rejection_user"
              class="okBox redBox f-c-c"
              @click.prevent="deleteUserFunc(v)"
            >
              عدم تایید
            </div>
            <!-- <b-img
              @click.prevent="editUserFunc(v)"
              class="ml-2"
              :src="require(`@/assets/images/gap/edit-icon.svg`)"
            ></b-img> -->
            <!-- <b-img
              @click.prevent="deleteUserFunc(v)"
              :src="require(`@/assets/images/gap/delete-icon.svg`)"
            ></b-img> -->
          </div>
        </div>
      </div>
      <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
        کاربری وجود ندارد.
      </div>
      <div class="paginationSection f-c-c w-100">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
    <div v-if="mobileUsers.length" class="mobileUserTable f-c-s f-d-c w-100">
      <div
        v-for="(v, i) in mobileUsers"
        :key="i"
        class="tableItem f-c-s f-d-c w-100 mb-3"
        :class="[v.flag == 'confirmed' ? 'grrenBack' : v.flag == 'rejected' ? 'redBack' : '']"
      >
        <div class="up f-c-b w-100 mb-3">
          <div class="right f-s-s f-d-c">
            <div class="labelItem f-c-c mb-2">نام :</div>
            <div class="labelItem f-c-c mb-2">موبایل :</div>
            <!-- <div class="labelItem f-c-c">ایمیل :</div> -->
            <div class="labelItem f-c-c mb-2">سازمان :</div>
            <div class="labelItem f-c-c mb-2">وضعیت :</div>
            <div class="labelItem f-c-c">کد :</div>
          </div>
          <div class="left f-e-e f-d-c">
            <div class="answerItem f-c-e mb-2">
              {{ v ? v.first_name + " " + v.last_name : "-" }}
            </div>
            <div class="answerItem f-c-e mb-2">
              {{ v.mobile ? v.mobile : "-" }}
            </div>
            <!-- <div class="answerItem f-c-e">
              {{ v.email ? v.email : "-" }}
            </div> -->
            <div class="answerItem f-c-e mb-2">
              {{ v.user_organ_title ? v.user_organ_title : "-" }}
            </div>
            <div class="answerItem f-c-e mb-2">
              {{ v.status ? v.status : "-" }}
            </div>
            <div class="answerItem f-c-e">
              {{ v.active_code ? v.active_code : "-" }}
            </div>
          </div>
        </div>
        <div class="down f-c-b w-100">
          <div
            v-if="user.permissions.confirmation_user"
            class="okBox f-c-c ml-1 w-50"
            @click.prevent="editUserFunc(v)"
          >
            تایید
          </div>
          <div
            v-if="user.permissions.rejection_user"
            class="okBox redBox f-c-c w-50"
            @click.prevent="deleteUserFunc(v)"
          >
            عدم تایید
          </div>
          <!-- <div class="edit f-c-c" @click.prevent="editUserFunc(v)">
            <b-img
              :src="require(`@/assets/images/mobile/edit-pen.svg`)"
            ></b-img>
          </div>
          <div class="delete f-c-c" @click.prevent="deleteUserFunc(v)">
            <b-img
              :src="require(`@/assets/images/mobile/delete-x.svg`)"
            ></b-img>
          </div> -->
        </div>
      </div>
    </div>
    <div
      v-else
      class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100"
    >
      کاربری وجود ندارد.
    </div>
    <b-modal
      id="edit-modal"
      modal-class="selectGroup"
      title="انتخاب سازمان"
      button-size="sm"
      :hide-footer="footer"
      ref="edit-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div
          class="row h-40"
          v-for="(v, i) in allOrganList.organ_list"
          :key="i"
        >
          <div
            class="checkboxSec f-c-s w-100"
            :class="[i == groups.length - 1 ? 'mb-4' : 'mb-2']"
          >
            <input
              type="checkbox"
              v-model="groupSelect"
              class="w-25"
              :id="'group' + i"
              :value="v.id"
            />
            <label :for="'group' + i">{{ v.title }}</label>
          </div>
        </div>
        <div class="btnSec w-100 f-c-c">
          <div class="finalbtn f-c-c" @click="acceptUserInGroupsFunc()">
            ذخیره
          </div>
        </div>
      </template>
    </b-modal>
    <DeleteConfirm
      v-if="isDelete"
      message="از عدم تایید مطمئن هستید ؟"
      titleValue="عدم تایید"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DeleteConfirm from "@/components/DelConfirmModal";
import { EventBus } from "@/assistant/EventBus";
export default {
  name: "MyUser",
  data() {
    return {
      iswatie: false,
      isSearchActive: false,
      activeId: 0,
      editUser: {
        name: "",
        mobile: "",
        role: "",
      },
      headerItem: ["تکی", "اکسلی"],
      addUser: {
        name: "",
        mobile: "",
        role: "",
        file: {},
      },
      currentPage: 1,
      perPage: 15,
      footer: true,
      isDelete: false,
      isEdit: false,
      userDeleted: {},
      userEdited: {},
      groupSelect: [],
      groups: [],
      roles: [
        { id: 1, name: "دانشجو" },
        { id: 2, name: "میهمان" },
      ],
      allUsers: [],
      users: [],
      mobileUsers: [],
    };
  },
  created() {
    this.getMyUsersFunction({
      user_id: this.user.user_id,
    });
    this.getAllOrganListFunction({
      user_id: this.user.user_id,
    });
    EventBus.$on("deleteItem", (status) => {
      if (status && this.isDelete) {
        this.isDelete = false;
        this.setOrganUserFunction({
          user_id: this.user.user_id,
          user_organ_id: this.userDeleted.id,
          organ_ids: "",
          status: "rejected",
        });
      } else {
        this.isDelete = false;
      }
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allMyUserData: (state) => state.gap.allMyUser,
      allOrganList: (state) => state.gap.allOrganList,
      setOrganUserStatus: (state) => state.gap.setOrganUserStatus,
    }),
    rows() {
      return this.users.length;
    },
    itemsForList() {
      return this.users.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },
  components: {
    DeleteConfirm,
  },
  methods: {
    ...mapActions("gap", [
      "getMyUsersFunction",
      "getAllOrganListFunction",
      "setOrganUserFunction",
    ]),
    searchFunc(v){
      let n = v.target.value
      let searchArray = this.allMyUserData.user_list.filter((ticket) => {
        return (
          ticket.first_name.toLowerCase().includes(n) ||
          ticket.last_name.toLowerCase().includes(n) ||
          ticket.mobile.toLowerCase().includes(n) ||
          ticket.status.toLowerCase().includes(n)
        );
      });
      this.users = searchArray;
      this.mobileUsers = searchArray;
    },
    searchIconFunc() {
      this.isSearchActive = !this.isSearchActive;
      setTimeout(() => {
        if (this.isSearchActive) {
          document.querySelector(".searchInputActive").focus();
        }
      }, 200);
    },
    acceptUserInGroupsFunc() {
      this.setOrganUserFunction({
        user_id: this.user.user_id,
        user_organ_id: this.userEdited.id,
        organ_ids: this.groupSelect.toString(),
        status: "confirmed",
      });
      this.$refs["edit-modal"].hide();
    },
    addFileFunc(e) {
      if (e) {
        if (this.addUser.file && this.addUser.file.name) {
          this.$bvToast.toast("تنها مجاز به ارسال یک فایل می باشید.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        } else {
          this.addUser.file = e;
        }
      }
    },
    deleteFileFunc() {
      this.addUser.file = {};
    },
    editUserFunc(v) {
      this.groupSelect = v.user_organ_ids.split(",");
      this.isEdit = true;
      this.userEdited = v;
      this.$refs["edit-modal"].show();
    },
    deleteUserFunc(v) {
      this.groupSelect = [];
      this.isDelete = true;
      this.userDeleted = v;
    },
    addNewUserFunc() {
      this.$refs["add-modal"].show();
    },
  },
  watch: {
    setOrganUserStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.getMyUsersFunction({
            user_id: this.user.user_id,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    allMyUserData(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.users = n.user_list;
          this.mobileUsers = n.user_list;
        } else {
          this.users = [];
          this.mobileUsers = [];
          this.iswatie = true;
        }
      }
    },
  },
  mounted() {
    if (Object.keys(this.allMyUserData).length) {
      if (this.allMyUserData.code == 100) {
        this.users = this.allMyUserData.users;
        this.mobileUsers = this.allMyUserData.users;
      } else {
        this.iswatie = true;
      }
    }
  },
};
</script>